import { render } from "./PageFooter.vue?vue&type=template&id=34777c42&scoped=true"
const script = {}

import "./PageFooter.vue?vue&type=style&index=0&id=34777c42&scoped=true&lang=scss"

import exportComponent from "E:\\TeamCity\\buildAgent\\work\\44e3aa492d05d81f\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34777c42"]])

export default __exports__